/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Unnamed_GroupInputs */

const en_team_manager_unnamed_group = /** @type {(inputs: Team_Manager_Unnamed_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unnamed Group`)
};

const fr_team_manager_unnamed_group = /** @type {(inputs: Team_Manager_Unnamed_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe sans nom`)
};

const de_team_manager_unnamed_group = /** @type {(inputs: Team_Manager_Unnamed_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbenannte Gruppe`)
};

const it_team_manager_unnamed_group = /** @type {(inputs: Team_Manager_Unnamed_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo senza nome`)
};

const ru_team_manager_unnamed_group = /** @type {(inputs: Team_Manager_Unnamed_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неназванная группа`)
};

const es_team_manager_unnamed_group = /** @type {(inputs: Team_Manager_Unnamed_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo sin nombre`)
};

const zh_cn2_team_manager_unnamed_group = /** @type {(inputs: Team_Manager_Unnamed_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未命名团体`)
};

const ja_team_manager_unnamed_group = /** @type {(inputs: Team_Manager_Unnamed_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前のないグループ`)
};

const hi_team_manager_unnamed_group = /** @type {(inputs: Team_Manager_Unnamed_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनाम समूह`)
};

const pt_pt2_team_manager_unnamed_group = /** @type {(inputs: Team_Manager_Unnamed_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo sem nome`)
};

/**
* | output |
* | --- |
* | "Unnamed Group" |
*
* @param {Team_Manager_Unnamed_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_unnamed_group = /** @type {((inputs?: Team_Manager_Unnamed_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Unnamed_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_unnamed_group(inputs)
	if (locale === "de") return de_team_manager_unnamed_group(inputs)
	if (locale === "it") return it_team_manager_unnamed_group(inputs)
	if (locale === "ru") return ru_team_manager_unnamed_group(inputs)
	if (locale === "es") return es_team_manager_unnamed_group(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_unnamed_group(inputs)
	if (locale === "ja") return ja_team_manager_unnamed_group(inputs)
	if (locale === "hi") return hi_team_manager_unnamed_group(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_unnamed_group(inputs)
	return en_team_manager_unnamed_group(inputs)
});